// extracted by mini-css-extract-plugin
export default {"loaderContainerV2":"AddQuestionLoader__loaderContainerV2___qO9KD","loaderData":"AddQuestionLoader__loaderData___fpsW9"};